var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcPayServiceBody2Mobile(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 171,
    height: 161,
    viewBox: "0 0 171 161",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2044_2781)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.621783,
    y: 1.17452,
    width: 106.442,
    height: 136.43,
    rx: 2.62299,
    fill: "#F3F3F3",
    stroke: "#EDEDED",
    strokeWidth: 0.749425
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.7871,
    y: 83.1035,
    width: 82.3056,
    height: 5.48704,
    rx: 2.74352,
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.7871,
    y: 68.4736,
    width: 82.3056,
    height: 5.48704,
    rx: 2.74352,
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.7871,
    y: 97.7363,
    width: 82.3056,
    height: 5.48704,
    rx: 2.74352,
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 12.7871,
    y: 112.376,
    width: 58.5284,
    height: 5.48704,
    rx: 2.74352,
    fill: "#CACACA"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M69.6881 28.1334L53.8643 21.292L37.7943 28.1334V36.0665C37.7943 40.6516 37.3997 45.4552 42.9047 52.7332C45.8111 56.5758 51.422 58.8953 53.8643 59.5746C55.7115 59.332 60.4401 57.6241 64.5777 52.7332C69.6881 46.6924 69.7086 39.5842 69.6881 36.0665V28.1334Z",
    fill: "#3A7EFC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.3564 41.5074L51.6101 46.47L60.8263 35.127",
    stroke: "white",
    strokeWidth: 1.49885,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M121.412 81.3401L139.891 54.9019C143.275 50.0598 142.631 43.4747 138.372 39.3801C137.065 38.1228 134.995 38.1307 133.697 39.398L101.275 71.0546C92.8567 79.2736 86.6821 89.5099 83.3381 100.789L74.1772 131.69C69.894 146.137 80.7573 160.625 95.826 160.563L142.86 160.367C147.135 160.349 151.203 158.521 154.053 155.335C156.808 152.256 157.528 147.859 155.901 144.062L155.196 142.418C160.336 141.971 164.606 138.268 165.774 133.243L166.077 131.941C166.962 128.135 165.291 124.194 161.941 122.184L162.993 121.868C166.825 120.718 169.465 117.211 169.509 113.21L169.541 110.324C169.592 105.694 166.318 101.693 161.77 100.825C166.182 100.825 169.827 97.3837 170.081 92.9795L170.267 89.7546C170.531 85.1879 166.899 81.3401 162.324 81.3401H121.412Z",
    fill: "#FFDCD5"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2044_2781"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 170.506,
    height: 159.888,
    fill: "white",
    transform: "translate(0.24707 0.799805)"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPayServiceBody2Mobile);
export default __webpack_public_path__ + "static/media/IcPayServiceBody2Mobile.1831afd0e685dbe3518044064439f71f.svg";
export { ForwardRef as ReactComponent };